import {
  createConstructor,
  createProjectStaff,
  createSaleOffice,
  deleteConstructor,
  deleteProjectStaff,
  deleteSaleOffice,
  getApartmentMaterials,
  getApartmentTypes,
  getConstructionStages,
  getConstructionTypes,
  getConstructors,
  getContentTypes,
  getCurrencies,
  getFlatAreaTypes,
  getFlatDecorations,
  getFlatStatuses,
  getMonths,
  getOccupiedByList,
  getOneConstructor,
  getOutputWindows,
  getPaymentInterests,
  getPaymentMethods,
  getPremisesDecorations,
  getProjectStaff,
  getQuarters,
  getRegions,
  getSaleOffices,
  getStageTypes,
  updateConstructor,
  updateProjectStaff,
  updateSaleOffice,
  deletePaymentInterest,
  createPaymentInterest,
  deletePaymentOption,
} from "@/api/knowledgeBase";

export default {
  FETCH_REGIONS({ commit }, params) {
    return new Promise((resolve, reject) => {
      getRegions(params)
        .then((response) => {
          commit("SET_REGIONS", response.data.results);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  FETCH_DISTRICTS({ commit }, params) {
    return new Promise((resolve, reject) => {
      getRegions(params)
        .then((response) => {
          commit("SET_DISTRICTS", response.data.results);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  FETCH_STAGE_TYPES({ commit }) {
    return new Promise((resolve, reject) => {
      getStageTypes()
        .then((response) => {
          commit("SET_STAGE_TYPES", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },

  FETCH_CURRENCIES({ commit }) {
    return new Promise((resolve, reject) => {
      getCurrencies()
        .then((response) => {
          commit("SET_CURRENCIES", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },

  FETCH_APARTMENT_MATERIALS({ commit }) {
    return new Promise((resolve, reject) => {
      getApartmentMaterials()
        .then((response) => {
          commit("SET_APARTMENT_MATERIALS", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },

  FETCH_PREMISES_DECORATIONS({ commit }) {
    return new Promise((resolve, reject) => {
      getPremisesDecorations()
        .then((response) => {
          commit("SET_PREMISES_DECORATIONS", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },

  FETCH_CONSTRUCTION_STAGES({ commit }) {
    return new Promise((resolve, reject) => {
      getConstructionStages()
        .then((response) => {
          commit("SET_CONSTRUCTION_STAGES", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },

  FETCH_PLANNING_TYPES({ commit }) {
    return new Promise((resolve, reject) => {
      getConstructionStages()
        .then((response) => {
          commit("SET_PLANNING_TYPES", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },

  FETCH_OUTPUT_WINDOWS({ commit }) {
    return new Promise((resolve, reject) => {
      getOutputWindows()
        .then((response) => {
          commit("SET_OUTPUT_WINDOWS", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },

  FETCH_MONTHS({ commit }, data) {
    return new Promise((resolve, reject) => {
      getMonths(data)
        .then((response) => {
          commit("SET_MONTHS", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },

  FETCH_QUARTERS({ commit }) {
    return new Promise((resolve, reject) => {
      getQuarters()
        .then((response) => {
          commit("SET_QUARTERS", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },

  FETCH_APARTMENT_TYPES({ commit }) {
    return new Promise((resolve, reject) => {
      getApartmentTypes()
        .then((response) => {
          commit("SET_APARTMENT_TYPES", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },

  FETCH_CONTRUCTION_TYPES({ commit }) {
    return new Promise((resolve, reject) => {
      getConstructionTypes()
        .then((response) => {
          commit("SET_CONTRUCTION_TYPES", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },

  FETCH_FLAT_STATUSES({ commit }) {
    return new Promise((resolve, reject) => {
      getFlatStatuses()
        .then((response) => {
          commit("SET_FLAT_STATUSES", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  FETCH_FLAT_DECORATIONS({ commit }) {
    return new Promise((resolve, reject) => {
      getFlatDecorations()
        .then((response) => {
          commit("SET_FLAT_DECORATIONS", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  FETCH_FLAT_LIVING_AREA_TYPES({ commit }) {
    return new Promise((resolve, reject) => {
      getFlatAreaTypes({ is_living: true })
        .then((response) => {
          commit("SET_FLAT_LIVING_AREA_TYPES", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  FETCH_FLAT_NONLIVING_AREA_TYPES({ commit }) {
    return new Promise((resolve, reject) => {
      getFlatAreaTypes({ is_living: false })
        .then((response) => {
          commit("SET_FLAT_NONLIVING_AREA_TYPES", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  FETCH_CONTENT_TYPE(a, data) {
    return getContentTypes(data);
  },
  FETCH_OCCUPIED_BY_LIST({ commit }) {
    return new Promise((resolve, reject) => {
      getOccupiedByList()
        .then((response) => {
          commit("SET_OCCUPIED_BY_LIST", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  FETCH_SALE_OFFICES({ commit }, data) {
    return new Promise((resolve, reject) => {
      getSaleOffices(data)
        .then((response) => {
          commit("SET_SALE_OFFICES", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  CREATE_SALE_OFFICE(_, data) {
    return createSaleOffice(data);
  },
  EDIT_SALE_OFFICE(_, data) {
    return updateSaleOffice(data);
  },
  DELETE_SALE_OFFICE(_, data) {
    return deleteSaleOffice(data);
  },

  FETCH_CONSTRUCTORS({ commit }, data) {
    return new Promise((resolve, reject) => {
      getConstructors(data)
        .then((response) => {
          commit("SET_CONSTRUCTORS", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  CREATE_CONSTRUCTOR(_, data) {
    return createConstructor(data);
  },
  EDIT_CONSTRUCTOR(_, data) {
    return updateConstructor(data);
  },
  DELETE_CONSTRUCTOR(_, data) {
    return deleteConstructor(data);
  },
  FETCH_PAYMENT_INTERESTS({ commit }) {
    return new Promise((resolve, reject) => {
      getPaymentInterests()
        .then((response) => {
          resolve(response.data);
          commit("SET_PAYMENT_INTERESTS", response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  DELETE_PAYMENT_INTEREST(_, data) {
    return deletePaymentInterest(data);
  },
  CREATE_PAYMENT_INTEREST(_, data) {
    return createPaymentInterest(data);
  },
  DELETE_PAYMENT_OPTION(_, data) {
    return deletePaymentOption(data);
  },
  FETCH_PAYMENT_METHODS({ commit }) {
    return new Promise((resolve, reject) => {
      getPaymentMethods()
        .then((response) => {
          resolve(response.data);
          commit("SET_PAYMENT_METHODS", response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  FETCH_ONE_CONSTRUCTOR({ commit }, data) {
    return new Promise((resolve, reject) => {
      getOneConstructor(data)
        .then((response) => {
          resolve(response.data);
          commit("SET_ONE_CONSTRUCTOR", response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  FETCH_PROJECT_STAFF({ commit }, data) {
    return new Promise((resolve, reject) => {
      getProjectStaff(data)
        .then((response) => {
          commit("SET_PROJECT_STAFF", response.data);
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  ADD_PROJECT_STAFF(_, data) {
    return createProjectStaff(data);
  },
  EDIT_PROJECT_STAFF(_, data) {
    return updateProjectStaff(data);
  },
  DELETE_PROJECT_STAFF(_, data) {
    return deleteProjectStaff(data);
  },
};
